import React from "react";

const Help = () => {
  return (
    <section className="py-5" style={{ background: "#f8fff8" }}>
      <div className="container">
        <div className="card shadow-lg border-0 rounded-4 p-4">
          <h3 className="fw-bold text-success mb-4">Help & Support</h3>
          <div className="accordion" id="helpAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#q1">
                  How to buy organic products?
                </button>
              </h2>
              <div id="q1" className="accordion-collapse collapse show" data-bs-parent="#helpAccordion">
                <div className="accordion-body">
                  Browse products, add to cart, and proceed to checkout with secure payment options.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q2">
                  How to contact support?
                </button>
              </h2>
              <div id="q2" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                <div className="accordion-body">
                  Email us at <b>support@organicmart.com</b> or call <b>+91 9876543210</b>.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q3">
                  Return & Refund Policy
                </button>
              </h2>
              <div id="q3" className="accordion-collapse collapse" data-bs-parent="#helpAccordion">
                <div className="accordion-body">
                  Returns are accepted within 7 days. Refunds will be processed to your original payment method.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <h6 className="fw-bold">Still need help?</h6>
            <a href="/ContactForm" className="btn btn-success mt-2">Contact Support</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Help;
